import { Header, Footer, ServiceCard, FAQCard } from '../components';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

export function CyberSecurity() {
  const { ref: heroRef, isVisible: heroVisible } = useScrollAnimation();
  const { ref: servicesRef, isVisible: servicesVisible } = useScrollAnimation();
  const { ref: faqRef, isVisible: faqVisible } = useScrollAnimation();

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#020816' }}>
      {/* Header */}
      <Header title="CommerceMinder" activePage="Siber Güvenlik" />

      {/* Hero Section */}
      <div
        ref={heroRef}
        className={`flex flex-col items-center align-self-stretch pt-24 px-4 md:px-[60px] transition-all duration-700 ease-out ${
          heroVisible
            ? 'opacity-100 transform translate-y-0'
            : 'opacity-0 transform translate-y-8'
        }`}
        style={{ gap: '15.09px' }}
      >
        <h1
          className="text-center text-3xl md:text-[48px]"
          style={{
            fontFamily: 'Inter',
            fontStyle: 'normal',
            fontWeight: '800',
            lineHeight: '76.8px',
            background: 'linear-gradient(93deg, #FFF 0%, #94A3B8 100%)',
            backgroundClip: 'text',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          }}
        >
          Güvenlik Hizmetlerimiz
        </h1>

        <p
          className="text-center max-w-2xl text-sm md:text-[17px] px-4 md:px-0"
          style={{
            color: '#7A8599',
            fontFamily: 'Inter',
            fontStyle: 'normal',
            fontWeight: '400',
            lineHeight: '27.2px',
          }}
        >
          İşletmenizi siber tehditlere karşı koruyacak kapsamlı güvenlik
          çözümlerimizi keşfedin. Detaylı bilgi almak için bizimle iletişime
          geçin.
        </p>
      </div>

      {/* Services Grid */}
      <div
        ref={servicesRef}
        className={`grid mx-auto mt-16 grid-cols-1 md:grid-cols-3 px-4 md:px-8 transition-all duration-700 ease-out ${
          servicesVisible
            ? 'opacity-100 transform translate-y-0'
            : 'opacity-0 transform translate-y-8'
        }`}
        style={{
          rowGap: '16px',
          columnGap: '16px',
          gridTemplateRows: 'repeat(auto, minmax(200px, auto))',
          justifyContent: 'center',
          maxWidth: '1200px',
          width: '100%',
        }}
      >
        <ServiceCard>
          <h3
            style={{
              color: '#E8ECF4',
              fontFamily: 'Inter',
              fontSize: '18px',
              fontWeight: '600',
              lineHeight: '28.8px',
              marginBottom: '12px',
            }}
          >
            Dış Ağ Zafiyet Tarama Testi
          </h3>
          <p
            style={{
              color: '#7A8599',
              fontFamily: 'Inter',
              fontSize: '14px',
              fontWeight: '400',
              lineHeight: '23.8px',
              marginBottom: '16px',
              flex: 1,
            }}
          >
            Dış Ağ Zafiyet Tarama Testi
          </p>
          <button
            onClick={() => {
              const contactForm = document.getElementById('contact-form');
              if (contactForm) {
                contactForm.scrollIntoView({
                  behavior: 'smooth',
                  block: 'start',
                });
              }
            }}
            style={{
              display: 'flex',
              padding: '11px 24px 12.39px 24px',
              justifyContent: 'center',
              alignItems: 'center',
              alignSelf: 'stretch',
              borderRadius: '10px',
              border: '1px solid #2A4A7F',
              background: 'transparent',
              color: '#60A5FA',
              textAlign: 'center',
              fontFamily: 'Inter',
              fontSize: '14px',
              fontWeight: '500',
              lineHeight: '22.4px',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
            }}
            onMouseEnter={e => {
              e.currentTarget.style.background = 'rgba(59, 130, 246, 0.2)';
              e.currentTarget.style.borderColor = '#60A5FA';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.background = 'transparent';
              e.currentTarget.style.borderColor = '#2A4A7F';
            }}
          >
            Bilgi Talep Et
          </button>
        </ServiceCard>

        <ServiceCard>
          <h3
            style={{
              color: '#E8ECF4',
              fontFamily: 'Inter',
              fontSize: '18px',
              fontWeight: '600',
              lineHeight: '28.8px',
              marginBottom: '12px',
            }}
          >
            İç Ağ Zafiyet Tarama Testi
          </h3>
          <p
            style={{
              color: '#7A8599',
              fontFamily: 'Inter',
              fontSize: '14px',
              fontWeight: '400',
              lineHeight: '23.8px',
              marginBottom: '16px',
              flex: 1,
            }}
          >
            İç ağ altyapınızdaki zafiyetleri tespit ederek kurumsal
            güvenliğinizi güçlendiriyoruz.
          </p>
          <button
            onClick={() => {
              const contactForm = document.getElementById('contact-form');
              if (contactForm) {
                contactForm.scrollIntoView({
                  behavior: 'smooth',
                  block: 'start',
                });
              }
            }}
            style={{
              display: 'flex',
              padding: '11px 24px 12.39px 24px',
              justifyContent: 'center',
              alignItems: 'center',
              alignSelf: 'stretch',
              borderRadius: '10px',
              border: '1px solid #2A4A7F',
              background: 'transparent',
              color: '#60A5FA',
              textAlign: 'center',
              fontFamily: 'Inter',
              fontSize: '14px',
              fontWeight: '500',
              lineHeight: '22.4px',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
            }}
            onMouseEnter={e => {
              e.currentTarget.style.background = 'rgba(59, 130, 246, 0.2)';
              e.currentTarget.style.borderColor = '#60A5FA';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.background = 'transparent';
              e.currentTarget.style.borderColor = '#2A4A7F';
            }}
          >
            Bilgi Talep Et
          </button>
        </ServiceCard>

        <ServiceCard>
          <h3
            style={{
              color: '#E8ECF4',
              fontFamily: 'Inter',
              fontSize: '18px',
              fontWeight: '600',
              lineHeight: '28.8px',
              marginBottom: '12px',
            }}
          >
            Kablosuz Ağ Zafiyet Tarama
          </h3>
          <p
            style={{
              color: '#7A8599',
              fontFamily: 'Inter',
              fontSize: '14px',
              fontWeight: '400',
              lineHeight: '23.8px',
              marginBottom: '16px',
              flex: 1,
            }}
          >
            Kablosuz ağ altyapınızın güvenlik durumunu analiz ederek riskleri
            minimize ediyoruz.
          </p>
          <button
            onClick={() => {
              const contactForm = document.getElementById('contact-form');
              if (contactForm) {
                contactForm.scrollIntoView({
                  behavior: 'smooth',
                  block: 'start',
                });
              }
            }}
            style={{
              display: 'flex',
              padding: '11px 24px 12.39px 24px',
              justifyContent: 'center',
              alignItems: 'center',
              alignSelf: 'stretch',
              borderRadius: '10px',
              border: '1px solid #2A4A7F',
              background: 'transparent',
              color: '#60A5FA',
              textAlign: 'center',
              fontFamily: 'Inter',
              fontSize: '14px',
              fontWeight: '500',
              lineHeight: '22.4px',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
            }}
            onMouseEnter={e => {
              e.currentTarget.style.background = 'rgba(59, 130, 246, 0.2)';
              e.currentTarget.style.borderColor = '#60A5FA';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.background = 'transparent';
              e.currentTarget.style.borderColor = '#2A4A7F';
            }}
          >
            Bilgi Talep Et
          </button>
        </ServiceCard>

        <ServiceCard>
          <h3
            style={{
              color: '#E8ECF4',
              fontFamily: 'Inter',
              fontSize: '18px',
              fontWeight: '600',
              lineHeight: '28.8px',
              marginBottom: '12px',
            }}
          >
            Oltalama (Phishing) Testi
          </h3>
          <p
            style={{
              color: '#7A8599',
              fontFamily: 'Inter',
              fontSize: '14px',
              fontWeight: '400',
              lineHeight: '23.8px',
              marginBottom: '16px',
              flex: 1,
            }}
          >
            Çalışanlarınızın sosyal mühendislik saldırılarına karşı
            farkındalığını ölçüyoruz.
          </p>
          <button
            onClick={() => {
              const contactForm = document.getElementById('contact-form');
              if (contactForm) {
                contactForm.scrollIntoView({
                  behavior: 'smooth',
                  block: 'start',
                });
              }
            }}
            style={{
              display: 'flex',
              padding: '11px 24px 12.39px 24px',
              justifyContent: 'center',
              alignItems: 'center',
              alignSelf: 'stretch',
              borderRadius: '10px',
              border: '1px solid #2A4A7F',
              background: 'transparent',
              color: '#60A5FA',
              textAlign: 'center',
              fontFamily: 'Inter',
              fontSize: '14px',
              fontWeight: '500',
              lineHeight: '22.4px',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
            }}
            onMouseEnter={e => {
              e.currentTarget.style.background = 'rgba(59, 130, 246, 0.2)';
              e.currentTarget.style.borderColor = '#60A5FA';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.background = 'transparent';
              e.currentTarget.style.borderColor = '#2A4A7F';
            }}
          >
            Bilgi Talep Et
          </button>
        </ServiceCard>

        <ServiceCard>
          <h3
            style={{
              color: '#E8ECF4',
              fontFamily: 'Inter',
              fontSize: '18px',
              fontWeight: '600',
              lineHeight: '28.8px',
              marginBottom: '12px',
            }}
          >
            Web Uygulama Zafiyet Denetimi
          </h3>
          <p
            style={{
              color: '#7A8599',
              fontFamily: 'Inter',
              fontSize: '14px',
              fontWeight: '400',
              lineHeight: '23.8px',
              marginBottom: '16px',
              flex: 1,
            }}
          >
            Web uygulamalarınızdaki güvenlik açıklarını OWASP standartlarına
            göre test ediyoruz.
          </p>
          <button
            onClick={() => {
              const contactForm = document.getElementById('contact-form');
              if (contactForm) {
                contactForm.scrollIntoView({
                  behavior: 'smooth',
                  block: 'start',
                });
              }
            }}
            style={{
              display: 'flex',
              padding: '11px 24px 12.39px 24px',
              justifyContent: 'center',
              alignItems: 'center',
              alignSelf: 'stretch',
              borderRadius: '10px',
              border: '1px solid #2A4A7F',
              background: 'transparent',
              color: '#60A5FA',
              textAlign: 'center',
              fontFamily: 'Inter',
              fontSize: '14px',
              fontWeight: '500',
              lineHeight: '22.4px',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
            }}
            onMouseEnter={e => {
              e.currentTarget.style.background = 'rgba(59, 130, 246, 0.2)';
              e.currentTarget.style.borderColor = '#60A5FA';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.background = 'transparent';
              e.currentTarget.style.borderColor = '#2A4A7F';
            }}
          >
            Bilgi Talep Et
          </button>
        </ServiceCard>

        <ServiceCard>
          <h3
            style={{
              color: '#E8ECF4',
              fontFamily: 'Inter',
              fontSize: '18px',
              fontWeight: '600',
              lineHeight: '28.8px',
              marginBottom: '12px',
            }}
          >
            Güvenlik Farkındalık Eğitimi
          </h3>
          <p
            style={{
              color: '#7A8599',
              fontFamily: 'Inter',
              fontSize: '14px',
              fontWeight: '400',
              lineHeight: '23.8px',
              marginBottom: '16px',
              flex: 1,
            }}
          >
            Çalışanlarınıza siber güvenlik farkındalığı kazandıran kapsamlı
            eğitim programları sunuyoruz.
          </p>
          <button
            onClick={() => {
              const contactForm = document.getElementById('contact-form');
              if (contactForm) {
                contactForm.scrollIntoView({
                  behavior: 'smooth',
                  block: 'start',
                });
              }
            }}
            style={{
              display: 'flex',
              padding: '11px 24px 12.39px 24px',
              justifyContent: 'center',
              alignItems: 'center',
              alignSelf: 'stretch',
              borderRadius: '10px',
              border: '1px solid #2A4A7F',
              background: 'transparent',
              color: '#60A5FA',
              textAlign: 'center',
              fontFamily: 'Inter',
              fontSize: '14px',
              fontWeight: '500',
              lineHeight: '22.4px',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
            }}
            onMouseEnter={e => {
              e.currentTarget.style.background = 'rgba(59, 130, 246, 0.2)';
              e.currentTarget.style.borderColor = '#60A5FA';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.background = 'transparent';
              e.currentTarget.style.borderColor = '#2A4A7F';
            }}
          >
            Bilgi Talep Et
          </button>
        </ServiceCard>
      </div>

      {/* Scope Form Section */}
      <div
        className="flex flex-col lg:flex-row items-start lg:items-center mt-16 mb-16 mx-auto px-4 md:px-8 py-8 lg:p-[60px] gap-4 lg:gap-[60px]"
        style={{
          maxWidth: '1200px',
          width: '100%',
          borderRadius: '20px',
          border: '1px solid #1C2535',
          background:
            'linear-gradient(113deg, rgba(15, 20, 35, 0.90) 0%, rgba(20, 30, 50, 0.90) 100%)',
        }}
      >
        {/* Left Side */}
        <div
          className="flex flex-col items-start"
          style={{
            gap: '16px',
            flex: '1 0 0',
          }}
        >
          {/* Badge */}
          <div
            className="flex items-start"
            style={{
              padding: '6px 16px',
              borderRadius: '20px',
              border: '1px solid rgba(59, 130, 246, 0.30)',
              background: 'rgba(59, 130, 246, 0.10)',
            }}
          >
            <span
              style={{
                color: '#60A5FA',
                fontFamily: 'Inter',
                fontSize: '13px',
                fontWeight: '400',
                lineHeight: '20.8px',
              }}
            >
              Sızma Testi
            </span>
          </div>

          {/* Title */}
          <h2
            className="text-2xl lg:text-[40px]"
            style={{
              color: '#F0F0F0',
              fontFamily: 'Inter',
              fontWeight: '700',
              lineHeight: '64px',
            }}
          >
            Kapsam Formu
          </h2>

          {/* Description */}
          <p
            className="text-sm lg:text-[17px] max-w-lg lg:max-w-[500px]"
            style={{
              color: '#7A8599',
              fontFamily: 'Inter',
              fontWeight: '400',
              lineHeight: '27.2px',
              marginBottom: '8px',
            }}
          >
            Sızma testi hizmeti talep etmek için kapsam formunu
            <br />
            indirip doldurduktan sonra bize e-posta ile iletebilirsiniz.
          </p>

          {/* Steps */}
          <div className="flex flex-col gap-4 mt-4">
            <div className="flex items-center gap-3">
              <div
                className="flex justify-center items-center"
                style={{
                  width: '32px',
                  height: '32px',
                  padding: '2.8px 0 4.2px 0',
                  borderRadius: '16px',
                  border: '1px solid rgba(59, 130, 246, 0.40)',
                  background: 'rgba(59, 130, 246, 0.15)',
                }}
              >
                <span
                  style={{
                    color: '#60A5FA',
                    textAlign: 'center',
                    fontFamily: 'Inter',
                    fontSize: '14px',
                    fontWeight: '600',
                    lineHeight: '22.4px',
                  }}
                >
                  1
                </span>
              </div>
              <span
                style={{
                  color: '#C0CAD8',
                  fontFamily: 'Inter',
                  fontSize: '15px',
                  fontWeight: '400',
                  lineHeight: '24px',
                }}
              >
                Formu indirin
              </span>
            </div>

            <div className="flex items-center gap-3">
              <div
                className="flex justify-center items-center"
                style={{
                  width: '32px',
                  height: '32px',
                  padding: '2.8px 0 4.2px 0',
                  borderRadius: '16px',
                  border: '1px solid rgba(59, 130, 246, 0.40)',
                  background: 'rgba(59, 130, 246, 0.15)',
                }}
              >
                <span
                  style={{
                    color: '#60A5FA',
                    textAlign: 'center',
                    fontFamily: 'Inter',
                    fontSize: '14px',
                    fontWeight: '600',
                    lineHeight: '22.4px',
                  }}
                >
                  2
                </span>
              </div>
              <span
                style={{
                  color: '#C0CAD8',
                  fontFamily: 'Inter',
                  fontSize: '15px',
                  fontWeight: '400',
                  lineHeight: '24px',
                }}
              >
                Gerekli alanları doldurun
              </span>
            </div>

            <div className="flex items-center gap-3">
              <div
                className="flex justify-center items-center"
                style={{
                  width: '32px',
                  height: '32px',
                  padding: '2.8px 0 4.2px 0',
                  borderRadius: '16px',
                  border: '1px solid rgba(59, 130, 246, 0.40)',
                  background: 'rgba(59, 130, 246, 0.15)',
                }}
              >
                <span
                  style={{
                    color: '#60A5FA',
                    textAlign: 'center',
                    fontFamily: 'Inter',
                    fontSize: '14px',
                    fontWeight: '600',
                    lineHeight: '22.4px',
                  }}
                >
                  3
                </span>
              </div>
              <span
                style={{
                  color: '#C0CAD8',
                  fontFamily: 'Inter',
                  fontSize: '15px',
                  fontWeight: '400',
                  lineHeight: '24px',
                }}
              >
                E-posta ile gönderin
              </span>
            </div>
          </div>

          {/* Email Contact */}
          <div
            className="flex items-center align-self-stretch mt-6"
            style={{
              padding: '14px 20px',
              gap: '10px',
              borderRadius: '10px',
              border: '1px solid #1C2535',
              background: 'rgba(59, 130, 246, 0.05)',
            }}
          >
            <div
              className="flex flex-col justify-center"
              style={{
                width: '280px',
                height: '23px',
                flexShrink: 0,
              }}
            >
              <span
                style={{
                  color: '#60A5FA',
                  fontFamily: 'Inter',
                  fontSize: '14px',
                  fontWeight: '500',
                  lineHeight: '22.4px',
                }}
              >
                security@commerceminder.com
              </span>
            </div>
          </div>
        </div>

        {/* Right Side - Form download card */}
        <div
          className="flex w-full lg:w-auto"
          style={{
            flex: '1 0 0',
          }}
        >
          <div
            className="flex flex-col items-center p-6 lg:p-[32px]"
            style={{
              gap: '19.9px',
              borderRadius: '16px',
              border: '1px solid #1C2535',
              background: 'rgba(10, 14, 23, 0.80)',
              width: '100%',
            }}
          >
            {/* Document Icon */}
            <div
              style={{
                color: '#FFF',
                textAlign: 'center',
                fontFamily: 'Inter',
                fontSize: '48px',
                fontWeight: '400',
                lineHeight: '76.8px',
              }}
            >
              📄
            </div>

            {/* File Name */}
            <div
              style={{
                color: '#E8ECF4',
                textAlign: 'center',
                fontFamily: 'Inter',
                fontSize: '15px',
                fontWeight: '600',
                lineHeight: '24px',
              }}
            >
              CommerceMinder_Kapsam_Formu.docx
            </div>

            {/* Description */}
            <div
              style={{
                color: '#7A8599',
                textAlign: 'center',
                fontFamily: 'Inter',
                fontSize: '13px',
                fontWeight: '400',
                lineHeight: '20.8px',
              }}
            >
              Zafiyet Tarama ve Sızma Testi Kapsam Formu
            </div>

            {/* File Size */}
            <div
              style={{
                color: '#4A5568',
                textAlign: 'center',
                fontFamily: 'Inter',
                fontSize: '12px',
                fontWeight: '400',
                lineHeight: '19.2px',
              }}
            >
              245 KB • DOCX
            </div>

            {/* Download Button */}
            <button
              className="flex items-center transition-all duration-300 hover:bg-[#2563EB] hover:shadow-[0_8px_25px_0_rgba(59,130,246,0.30)]"
              onClick={() => {
                const link = document.createElement('a');
                link.href = '/downloads/CommerceMinder_Kapsam_Formu.docx';
                link.download = 'CommerceMinder_Kapsam_Formu.docx';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              }}
              style={{
                padding: '14px 32px',
                gap: '8px',
                borderRadius: '10px',
                background: '#3B82F6',
                border: 'none',
                cursor: 'pointer',
              }}
            >
              <img
                src="/icons/download.svg"
                alt="download"
                className="w-4 h-4"
                style={{ filter: 'brightness(0) invert(1)' }}
              />
              <span
                style={{
                  color: '#FFF',
                  fontFamily: 'Inter',
                  fontSize: '14px',
                  fontWeight: '500',
                  lineHeight: '22.4px',
                }}
              >
                İndir
              </span>
            </button>
          </div>
        </div>
      </div>

      {/* FAQ Section */}
      <div
        className="flex flex-col lg:flex-row items-start mx-auto px-4 md:px-8 py-12 lg:py-20 gap-8 lg:gap-20"
        style={{
          maxWidth: '1200px',
          width: '100%',
        }}
      >
        {/* Left Side - Title and Description */}
        <div className="flex flex-col items-start gap-4 w-full lg:flex-1">
          <h2
            className="text-3xl lg:text-[48px]"
            style={{
              color: '#F0F0F0',
              fontFamily: 'Inter',
              fontWeight: '700',
              lineHeight: '55.2px',
            }}
          >
            Sıkça Sorulan
            <br />
            Sorular
          </h2>

          <p
            className="text-sm lg:text-[15px]"
            style={{
              color: '#7A8599',
              fontFamily: 'Inter',
              fontWeight: '400',
              lineHeight: '25.5px',
            }}
          >
            Siber güvenlik hizmetlerimiz hakkında merak
            <br className="hidden lg:block" />
            ettiğiniz soruların yanıtlarını burada
            <br className="hidden lg:block" />
            bulabilirsiniz.
          </p>
        </div>

        {/* Right Side - FAQ Cards */}
        <div
          ref={faqRef}
          className={`flex flex-col gap-4 w-full lg:flex-1 transition-all duration-700 ease-out ${
            faqVisible
              ? 'opacity-100 transform translate-y-0'
              : 'opacity-0 transform translate-y-8'
          }`}
        >
          <FAQCard
            question="Sızma testi nedir ve neden gereklidir?"
            answer="Sızma testi, siber saldırganların sisteminize nasıl sızabileceğini tespit etmek için yapılan güvenlik testleridir. Bu testler sayesinde güvenlik açıklarını önceden tespit ederek siber saldırılara karşı korunabilirsiniz."
          />
          <FAQCard
            question="Hizmet fiyatlarınız nasıl belirleniyor?"
            answer="Fiyatlar test kapsamına, sistem karmaşıklığına ve süresine göre belirlenir. Kapsam formunu doldurduktan sonra size özel teklif hazırlanır. Her proje için detaylı analiz yapılarak makul fiyat sunulur."
          />
          <FAQCard
            question="Kapsam formunu nasıl doldurup gönderebilirim?"
            answer="Sayfadan kapsam formunu indirip gerekli alanları doldurun. Doldurduğunuz formu security@commerceminder.com adresine e-posta ile gönderin. Ekip 24 saat içinde geri dönüş yapacaktır."
          />
          <FAQCard
            question="Test süreci iş sürekliliğimi etkiler mi?"
            answer="Hayır, testler iş sürekliliğini etkilemeyecek şekilde planlanır. Testler genellikle mesai saatleri dışında veya düşük trafik saatlerinde yapılır. Kritik sistemlere müdahale öncesi mutlaka onay alınır."
          />
          <FAQCard
            question="Phishing testi çalışanlarımı nasıl etkiler?"
            answer="Phishing testleri çalışanların güvenlik farkındalığını artırmaya yöneliktir. Test sonrası kimlik bilgileri paylaşılmaz, sadece eğitim amaçlı geri bildirim verilir. Amaç çalışanları cezalandırmak değil, bilinçlendirmektir."
          />
          <FAQCard
            question="Güvenlik farkındalık eğitimi online mı yerinde mi?"
            answer="Her iki seçenek de sunulmaktadır. Online eğitimler interaktif modüllerle, yerinde eğitimler ise yüz yüze workshop formatında gerçekleşir. İhtiyaca göre hibrit model de uygulanabilir."
          />
          <FAQCard
            question="Test sonrası ne tür bir rapor alıyorum?"
            answer="Detaylı teknik rapor, yönetici özeti ve düzeltme önerileri içeren kapsamlı bir rapor hazırlanır. Risk seviyeleri, tespit edilen zafiyetler ve çözüm adımları net bir şekilde belirtilir."
          />
          <FAQCard
            question="KOBİ paketiniz neleri kapsıyor?"
            answer="KOBİ paketi dış ağ zafiyet tarama, temel web uygulama testi ve güvenlik farkındalık eğitimi içerir. Küçük ve orta ölçekli işletmeler için uygun fiyatlı, kapsamlı güvenlik çözümü sunar."
          />
        </div>
      </div>

      {/* Contact Form Section */}
      <div
        className="flex flex-col items-center mx-auto px-4 md:px-8 py-12 lg:py-20 gap-8 lg:gap-12"
        style={{ maxWidth: '1200px', width: '100%' }}
      >
        {/* Title */}
        <h2
          className="text-2xl lg:text-[36px] text-center"
          style={{
            color: '#F0F0F0',
            fontFamily: 'Inter',
            fontWeight: '700',
            lineHeight: '57.6px',
          }}
        >
          Bilgi Talep Et
        </h2>

        {/* Description */}
        <p
          className="text-sm lg:text-[15px] text-center px-4 lg:px-0"
          style={{
            color: '#7A8599',
            fontFamily: 'Inter',
            fontWeight: '400',
            lineHeight: '24px',
          }}
        >
          Hizmetlerimiz hakkında detaylı bilgi almak için formu doldurun,
          ekibimiz en kısa sürede sizinle iletişime geçsin.
        </p>

        {/* Contact Form */}
        <form
          id="contact-form"
          className="flex flex-col items-start w-full p-6 lg:p-10 gap-5"
          style={{
            maxWidth: '56rem',
            borderRadius: '18px',
            background: '#16191F',
          }}
        >
          {/* First Row - Two Inputs */}
          <div className="flex flex-col lg:flex-row gap-4 w-full">
            <div className="flex flex-col flex-1">
              <label
                style={{
                  color: '#94A3B8',
                  fontFamily: 'Inter',
                  fontSize: '13px',
                  fontWeight: '500',
                  lineHeight: '20.8px',
                  letterSpacing: '0.5px',
                  textTransform: 'uppercase',
                  marginBottom: '8px',
                }}
              >
                FİRMA ADI
              </label>
              <input
                type="text"
                className="flex flex-col items-start align-self-stretch"
                style={{
                  padding: '14px 18px',
                  borderRadius: '10px',
                  border: '1px solid #1C2535',
                  background: 'rgba(10, 14, 23, 0.80)',
                  color: '#FFF',
                  outline: 'none',
                }}
                placeholder="Firma adınızı girin"
              />
            </div>

            <div className="flex flex-col flex-1">
              <label
                style={{
                  color: '#94A3B8',
                  fontFamily: 'Inter',
                  fontSize: '13px',
                  fontWeight: '500',
                  lineHeight: '20.8px',
                  letterSpacing: '0.5px',
                  textTransform: 'uppercase',
                  marginBottom: '8px',
                }}
              >
                YETKİLİ ADI SOYADI
              </label>
              <input
                type="text"
                className="flex flex-col items-start align-self-stretch"
                style={{
                  padding: '14px 18px',
                  borderRadius: '10px',
                  border: '1px solid #1C2535',
                  background: 'rgba(10, 14, 23, 0.80)',
                  color: '#FFF',
                  outline: 'none',
                }}
                placeholder="Yetkili adı soyadı girin"
              />
            </div>
          </div>

          {/* Second Row - Two Inputs */}
          <div className="flex flex-col lg:flex-row gap-4 w-full">
            <div className="flex flex-col flex-1">
              <label
                style={{
                  color: '#94A3B8',
                  fontFamily: 'Inter',
                  fontSize: '13px',
                  fontWeight: '500',
                  lineHeight: '20.8px',
                  letterSpacing: '0.5px',
                  textTransform: 'uppercase',
                  marginBottom: '8px',
                }}
              >
                E-POSTA
              </label>
              <input
                type="email"
                className="flex flex-col items-start align-self-stretch"
                style={{
                  padding: '14px 18px',
                  borderRadius: '10px',
                  border: '1px solid #1C2535',
                  background: 'rgba(10, 14, 23, 0.80)',
                  color: '#FFF',
                  outline: 'none',
                }}
                placeholder="E-posta adresinizi girin"
              />
            </div>

            <div className="flex flex-col flex-1">
              <label
                style={{
                  color: '#94A3B8',
                  fontFamily: 'Inter',
                  fontSize: '13px',
                  fontWeight: '500',
                  lineHeight: '20.8px',
                  letterSpacing: '0.5px',
                  textTransform: 'uppercase',
                  marginBottom: '8px',
                }}
              >
                TELEFON
              </label>
              <input
                type="tel"
                className="flex flex-col items-start align-self-stretch"
                style={{
                  padding: '14px 18px',
                  borderRadius: '10px',
                  border: '1px solid #1C2535',
                  background: 'rgba(10, 14, 23, 0.80)',
                  color: '#FFF',
                  outline: 'none',
                }}
                placeholder="Telefon numaranızı girin"
              />
            </div>
          </div>

          {/* Services Checkboxes */}
          <div className="w-full mt-4">
            <label
              style={{
                color: '#94A3B8',
                fontFamily: 'Inter',
                fontSize: '13px',
                fontWeight: '500',
                lineHeight: '20.8px',
                letterSpacing: '0.5px',
                textTransform: 'uppercase',
                marginBottom: '16px',
                display: 'block',
              }}
            >
              İLGİLENDİĞİNİZ HİZMETLER
            </label>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
              <div
                className="flex items-center justify-self-stretch"
                style={{
                  height: '46.8px',
                  padding: '12px 16px',
                  gap: '20px',
                  borderRadius: '8px',
                  border: '1px solid #1C2535',
                  background: 'rgba(10, 14, 23, 0.50)',
                }}
              >
                <input
                  type="checkbox"
                  id="external-vulnerability-test"
                  style={{
                    width: '18px',
                    height: '18px',
                    borderRadius: '2.5px',
                    border: '1px solid #767676',
                    background: '#FFF',
                  }}
                />
                <label
                  htmlFor="external-vulnerability-test"
                  className="text-white text-sm"
                >
                  Dış Ağ Zafiyet Tarama Testi
                </label>
              </div>

              <div
                className="flex items-center justify-self-stretch"
                style={{
                  height: '46.8px',
                  padding: '12px 16px',
                  gap: '20px',
                  borderRadius: '8px',
                  border: '1px solid #1C2535',
                  background: 'rgba(10, 14, 23, 0.50)',
                }}
              >
                <input
                  type="checkbox"
                  id="wireless-vulnerability-test"
                  style={{
                    width: '18px',
                    height: '18px',
                    borderRadius: '2.5px',
                    border: '1px solid #767676',
                    background: '#FFF',
                  }}
                />
                <label
                  htmlFor="wireless-vulnerability-test"
                  className="text-white text-sm"
                >
                  Kablosuz Ağ Zafiyet Tarama
                </label>
              </div>

              <div
                className="flex items-center justify-self-stretch"
                style={{
                  height: '46.8px',
                  padding: '12px 16px',
                  gap: '20px',
                  borderRadius: '8px',
                  border: '1px solid #1C2535',
                  background: 'rgba(10, 14, 23, 0.50)',
                }}
              >
                <input
                  type="checkbox"
                  id="web-app-vulnerability-test"
                  style={{
                    width: '18px',
                    height: '18px',
                    borderRadius: '2.5px',
                    border: '1px solid #767676',
                    background: '#FFF',
                  }}
                />
                <label
                  htmlFor="web-app-vulnerability-test"
                  className="text-white text-sm"
                >
                  Web Uygulama Zafiyet Denetimi
                </label>
              </div>

              <div
                className="flex items-center justify-self-stretch"
                style={{
                  height: '46.8px',
                  padding: '12px 16px',
                  gap: '20px',
                  borderRadius: '8px',
                  border: '1px solid #1C2535',
                  background: 'rgba(10, 14, 23, 0.50)',
                }}
              >
                <input
                  type="checkbox"
                  id="internal-vulnerability-test"
                  style={{
                    width: '18px',
                    height: '18px',
                    borderRadius: '2.5px',
                    border: '1px solid #767676',
                    background: '#FFF',
                  }}
                />
                <label
                  htmlFor="internal-vulnerability-test"
                  className="text-white text-sm"
                >
                  İç Ağ Zafiyet Tarama Testi
                </label>
              </div>

              <div
                className="flex items-center justify-self-stretch"
                style={{
                  height: '46.8px',
                  padding: '12px 16px',
                  gap: '20px',
                  borderRadius: '8px',
                  border: '1px solid #1C2535',
                  background: 'rgba(10, 14, 23, 0.50)',
                }}
              >
                <input
                  type="checkbox"
                  id="phishing-test"
                  style={{
                    width: '18px',
                    height: '18px',
                    borderRadius: '2.5px',
                    border: '1px solid #767676',
                    background: '#FFF',
                  }}
                />
                <label htmlFor="phishing-test" className="text-white text-sm">
                  Oltalama (Phishing) Testi
                </label>
              </div>

              <div
                className="flex items-center justify-self-stretch"
                style={{
                  height: '46.8px',
                  padding: '12px 16px',
                  gap: '20px',
                  borderRadius: '8px',
                  border: '1px solid #1C2535',
                  background: 'rgba(10, 14, 23, 0.50)',
                }}
              >
                <input
                  type="checkbox"
                  id="security-awareness-training"
                  style={{
                    width: '18px',
                    height: '18px',
                    borderRadius: '2.5px',
                    border: '1px solid #767676',
                    background: '#FFF',
                  }}
                />
                <label
                  htmlFor="security-awareness-training"
                  className="text-white text-sm"
                >
                  Güvenlik Farkındalık Eğitimi
                </label>
              </div>
            </div>
          </div>

          {/* Additional Notes */}
          <div className="w-full">
            <label
              style={{
                color: '#94A3B8',
                fontFamily: 'Inter',
                fontSize: '13px',
                fontWeight: '500',
                lineHeight: '20.8px',
                letterSpacing: '0.5px',
                textTransform: 'uppercase',
                marginBottom: '8px',
                display: 'block',
              }}
            >
              EK NOTLAR
            </label>
            <textarea
              rows={4}
              className="w-full"
              style={{
                padding: '14px 18px',
                borderRadius: '10px',
                border: '1px solid #1C2535',
                background: 'rgba(10, 14, 23, 0.80)',
                color: '#FFF',
                outline: 'none',
                resize: 'vertical',
              }}
              placeholder="Ek bilgiler, özel gereksinimler veya sorularınızı buraya yazabilirsiniz..."
            />
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            className="flex justify-center items-center w-full transition-all duration-300 hover:bg-[#2563EB] hover:shadow-[0_8px_30px_0_rgba(59,130,246,0.30)]"
            style={{
              padding: '16px',
              borderRadius: '12px',
              background: '#3B82F6',
              border: 'none',
              cursor: 'pointer',
            }}
          >
            <span
              style={{
                color: '#FFF',
                fontFamily: 'Inter',
                fontSize: '16px',
                fontWeight: '600',
                lineHeight: '24px',
              }}
            >
              Bilgi Gönder
            </span>
          </button>
        </form>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
}
